import React from 'react'
import MainContainer from '../MainContainer'
import QCContent from './QCContent'

export default function Control() {
  return (
    <MainContainer actived={["result"]}>
       <QCContent />
    </MainContainer>
  )
}
